import * as React from "react";
import { memo } from "react";

const SvgGrill = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.573 8.622a.941.941 0 0 0 .647-.905c0-.55-.42-.97-.97-.97H.97c-.55 0-.97.42-.97.97 0 .42.29.776.646.905.097 2.553 1.713 4.75 3.975 5.688l-1.454 2.553a1.827 1.827 0 0 0-.582-.097A1.6 1.6 0 0 0 .97 18.382a1.6 1.6 0 0 0 1.615 1.616 1.6 1.6 0 0 0 1.616-1.616c0-.097 0-.227-.032-.324h6.819l1.002 1.778c.224.336.758.12.582-.323l-2.973-5.171a6.55 6.55 0 0 0 3.974-5.72ZM.97 7.394h12.28c.194 0 .323.129.323.323s-.129.323-.323.323H.97c-.194 0-.324-.13-.324-.323 0-.194.13-.323.324-.323ZM2.586 19.35c-.55 0-.97-.42-.97-.97 0-.549.42-.969.97-.969.549 0 .97.42.97.97-.001.55-.421.97-.97.97Zm8.014-1.939H3.878c-.064-.064-.097-.129-.161-.194l1.519-2.682a5.983 5.983 0 0 0 1.874.29c.646 0 1.292-.096 1.874-.29l1.616 2.876Zm-3.49-3.231a5.787 5.787 0 0 1-5.785-5.494h11.602c-.194 3.07-2.714 5.494-5.817 5.494ZM6.82 2.74a2.602 2.602 0 0 0 0-2.295c-.066-.162 0-.356.128-.42.162-.065.356 0 .42.129a3.217 3.217 0 0 1 0 2.876 2.602 2.602 0 0 0 0 2.294c.16.399-.353.651-.549.259a3.149 3.149 0 0 1 0-2.844Zm-1.94 0a2.602 2.602 0 0 0 0-2.295c-.065-.162 0-.356.13-.42.16-.065.355 0 .42.129a3.217 3.217 0 0 1 0 2.876 2.602 2.602 0 0 0 0 2.294c.159.399-.354.651-.55.259a3.149 3.149 0 0 1 0-2.844Zm3.878 0a2.6 2.6 0 0 0 0-2.295c-.064-.162 0-.356.13-.42.16-.065.355 0 .42.129a3.217 3.217 0 0 1 0 2.876 2.602 2.602 0 0 0 0 2.294c.159.399-.354.65-.55.259a3.149 3.149 0 0 1 0-2.844Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgGrill);
export default Memo;
